import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import type { UsageTransitionRow } from '../types';
import { formatCount, formatPercent } from '../services/usageFormat';
import SchutzZeile from './SchutzZeile';
import DatenTabelle, { zahlenZelle } from './DatenTabelle';
import { nutzerText } from './SeitenTabelle';

/**
 * RITA-1505 (Nutzungserfassung Phase 2c) — häufigste Seitenwechsel.
 *
 * Rücksprung heißt: zurück zur vorigen Seite innerhalb von 10 Sekunden. Ein hoher Anteil ist ein
 * Hinweis auf einen Umweg, kein Urteil über die Person.
 */
export interface WegeTabelleProps {
  rows: UsageTransitionRow[];
}

export default function WegeTabelle({ rows }: WegeTabelleProps) {
  return (
    <DatenTabelle
      leer={rows.length === 0}
      leerText="Im Zeitraum sind keine Seitenwechsel verdichtet."
      spalten={[
        { titel: 'Von' },
        { titel: 'Nach' },
        { titel: 'Anzahl', numerisch: true },
        { titel: 'Nutzer', numerisch: true },
        { titel: 'Rücksprung', numerisch: true },
      ]}
    >
      {rows.map((row, stelle) => (
        // eslint-disable-next-line react/no-array-index-key
        <TableRow key={`${row.label}-${stelle}`}>
          <TableCell>
            <SchutzZeile
              suppressed={row.suppressed}
              groups={row.groups}
              users={row.users}
              bezeichner={row.fromRoute}
              technisch
            />
          </TableCell>
          <TableCell>
            {row.suppressed ? (
              '–'
            ) : (
              <SchutzZeile
                suppressed={false}
                groups={row.groups}
                users={row.users}
                bezeichner={row.toRoute}
                technisch
              />
            )}
          </TableCell>
          <TableCell sx={zahlenZelle}>{formatCount(row.count)}</TableCell>
          <TableCell sx={zahlenZelle}>{nutzerText(row.users, row.usersEstimated)}</TableCell>
          <TableCell sx={zahlenZelle}>{formatPercent(row.bounceRate)}</TableCell>
        </TableRow>
      ))}
    </DatenTabelle>
  );
}
